import { useMemo } from 'react';
import { formatContextInstructions, formatResponseInstructions } from 'copilot-toolkit/utils/interactiveModeUtils';
import { feInteractionsToFrontEndTools } from 'copilot-toolkit/utils/jsonSchemaUtils';
import { useIsInteractiveModePluginEnabled } from '../../gating/hooks/useHasAccess';
import { useCollaborationParentState } from '../../hooks/useCollaborationParentState';
import { INTERACTIVE_MODE_PLUGIN } from '../../types/PluginTypes';
import { useSelector } from 'react-redux';
import { selectIsInteractiveModeActive } from '../../chat/selectors/chatv2Selectors';

// Take the state from the hook, transform it for the BE interface
export const useGetTransformedInteractiveStateForBackend = () => {
  const isInteractiveModePluginEnabled = useIsInteractiveModePluginEnabled();
  const {
    getParentAppStateByPlugin
  } = useCollaborationParentState();
  const {
    customFEActions
  } = getParentAppStateByPlugin(INTERACTIVE_MODE_PLUGIN) || {};
  const isInteractiveModeActive = useSelector(selectIsInteractiveModeActive);
  return useMemo(() => {
    // If user doesn't have access
    // Or the hook isn't running...
    // Don't return anything
    if (!isInteractiveModePluginEnabled || !isInteractiveModeActive) {
      return undefined;
    }
    const responseInstructions = formatResponseInstructions(customFEActions.additionalLLMInstructions);
    const actionContext = formatContextInstructions(customFEActions.interactions);
    const frontEndTools = feInteractionsToFrontEndTools(customFEActions.interactions);
    return {
      // Additional llm instructions - general instructions for the LLM about how to interact with the FE actions
      responseInstructions,
      // Used to invoke FE functions - passed back via `interactive_tool_call`
      frontEndTools,
      // The current state of the FE actions - and anything else that might be needed
      actionContext
    };
  }, [isInteractiveModePluginEnabled, customFEActions, isInteractiveModeActive]);
};